import { Navigate, Route, Routes } from 'react-router-dom';

import { PATH } from 'constants/path';

import PermissionsPage from './page/PermissionsPage';

const PermissionsRouters = () => {
  return (
    <Routes>
      <Route index element={<PermissionsPage />} />

      <Route path="*" element={<Navigate to={PATH.ERROR_404} />} />
    </Routes>
  );
};

export default PermissionsRouters;
